import { Avatar, Input, InputGroup, InputLeftElement } from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";
import React, { useState, useEffect } from "react";
import { VStack, Box } from "@chakra-ui/react";
import { 
    Modal,
    ModalOverlay,
    ModalContent,
    ModalBody,
    ModalHeader,
    ModalFooter,
    ModalCloseButton,
    Text,
    Button,
    HStack
} from "@chakra-ui/react";
import apiClient from "../../clients/apiClient.js";
import { useParams } from "react-router-dom";

const CollaboratorModal = ({isModalOpen, setIsModalOpen, allCollaborators, questionData, existingCollaborators, setExistingCollaborators}) => {
    const [filteredCollaborators, setFilteredCollaborators] = useState(allCollaborators);
    const [filter, setFilter] = useState("");
    const {formId} = useParams();


    const searchCollaborators = (e) => {
        const query = e.target.value.toLowerCase();
        setFilter(query);
        setFilteredCollaborators(
            allCollaborators.filter((collaborator) =>
                collaborator.email.toLowerCase().includes(query) ||
                collaborator.first_name.toLowerCase().includes(query) ||
                collaborator.last_name.toLowerCase().includes(query) ||
                collaborator.department.toLowerCase().includes(query)
            )
        );
    }

    const addCollaborator = (collaborator) => {
        apiClient.post("/forms/update-collaborators", {
            form_id: formId,
            entity_id: questionData.id,
            action: "add",
            collaborators: [{
                email: collaborator.email,
            }]
        }).then((response) => {
            if (response.status === 200) {
                setExistingCollaborators((prevCollaborators) => [
                    ...prevCollaborators,
                    collaborator
                ]);
            }
        })
    }

    const removeCollaborator = (collaborator) => {
        apiClient.post("/forms/update-collaborators", {
            form_id: formId,
            entity_id: questionData.id,
            action: "remove",
            collaborators: [{
                email: collaborator.email,
            }]
        }).then((response) => {
            if (response.status === 200) {
                setExistingCollaborators((prevCollaborators) =>
                    prevCollaborators.filter((c) => c.email !== collaborator.email)
                );
            }
        });
    }

    return (
        <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Add Collaborator</ModalHeader>
                <ModalCloseButton />
                <ModalBody paddingBottom={"16px"}>
                    <HStack align="stretch" spacing={4}>
                        <InputGroup>
                            <InputLeftElement pointerEvents="none">
                                <SearchIcon color="gray.300" />
                            </InputLeftElement>
                            <Input
                                placeholder="Collaborators"
                                variant="outline"
                                focusBorderColor="blue.500"
                                value={filter}
                                onChange={searchCollaborators}
                            />
                        </InputGroup>
                    </HStack>

                    {filteredCollaborators?.length > 0 && filter?.length > 0 &&  (
                        <Box
                            border="1px solid"
                            borderColor="gray.200"
                            borderRadius="md"
                            boxShadow="sm"
                            maxHeight="200px"
                            overflowY="auto"
                            bg="white"
                            data-scrollable="true"
                        >
                            {filteredCollaborators.map((collaborator, index) => (
                                <Box
                                    key={index}
                                    px={4}
                                    py={2}
                                    _hover={{ bg: "gray.100", cursor: "pointer" }}
                                    onClick={() => console.log(`Selected: ${collaborator}`)}
                                    display={"flex"}
                                    justifyContent={"space-between"}
                                >
                                    <Text>
                                        {collaborator.email}
                                    </Text>
                                    <Button
                                        colorScheme="blue"
                                        onClick={() => addCollaborator(collaborator)}
                                    >
                                        Add
                                    </Button>
                                </Box>
                            ))}
                        </Box>
                    )}
                    {
                        existingCollaborators?.length > 0 && (
                            <Text mt={4} fontWeight="bold">
                                People with access
                            </Text>
                        )
                    }
                    <VStack align="start" spacing={4} mt={4}>
                        {existingCollaborators.map((collaborator, index) => (
                            <HStack
                                key={index}
                                justifyContent="space-between"
                                width="100%"
                            >
                                <HStack>
                                    <Avatar
                                        sx={{
                                        boxSize: "40px"
                                        }}
                                        name={collaborator.first_name + " " + collaborator.last_name}
                                        src={collaborator.profile_photo}
                                    />
                                    <VStack align="start" gap={0}>
                                        <Text p={0} m={0} fontSize={"14px"}>{collaborator.first_name + " " + collaborator.last_name}</Text>
                                        <Text p={0} m={0} fontSize={"13px"}>{collaborator.email}</Text>
                                    </VStack>
                                </HStack>
                                <Button
                                    colorScheme="red"
                                    size="sm"
                                    onClick={() => removeCollaborator(collaborator)}
                                >
                                    Remove
                                </Button>
                            </HStack>
                        ))}
                    </VStack>
                </ModalBody>
            </ModalContent>
        </Modal>
    );
}

export default CollaboratorModal;